import { render, staticRenderFns } from "./copies-details.vue?vue&type=template&id=10a91146&scoped=true"
import script from "./copies-details.vue?vue&type=script&lang=js"
export * from "./copies-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a91146",
  null
  
)

export default component.exports